<template>
  <v-col class="d-flex flex-column text-center">
    <div v-if="small" class="mt-8"></div>
    <v-spacer></v-spacer>
    <v-card
      flat
      class="radius mx-auto"
      :class="small ? 'px-5' : 'px-12'"
      max-width="485"
      :min-width="$vuetify.breakpoint.lgAndUp ? 485 : 340"
    >
      <v-container fluid>
        <v-row>
          <v-col class="d-flex justify-center ma-2">
            <v-img
              src="../assets/logo_text_bellow.png"
              :max-height="small ? 80 : 105"
              contain
              max-width="110"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="flex-column mb-0" :class="small ? 'ma-3 px-4' : 'ma-6'">
            <p class="font-weight-bold subtitle-2 text-center mb-0 ubuntu">
              Account recovering
              <br />
              <span class="font-weight-light subtitle-2 ubuntu"
                >Please enter your new password.</span
              >
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center">
            <v-form ref="form">
              <v-text-field
                v-model="new_password1"
                label="Password"
                type="password"
                :success-messages="correctPassword"
                hint="Must contain at least one numeric digit and one lowercase letter"
                :rules="[(v) => !!v || 'Password required.', rules.min, rules.num, rules.letter]"
              ></v-text-field>
              <v-text-field
                v-model="new_password2"
                label="Repeat your new password"
                type="password"
                :success-messages="goodPassword2"
                :rules="[(v) => !!v || 'Confirm Password required.', rules.identical]"
              ></v-text-field>
              <v-card-actions>
                <v-row justify="space-between" class="px-1">
                  <v-btn
                    class="text-capitalize"
                    width="120"
                    outlined
                    @click="goLogin"
                    color="#262626"
                    >Cancel</v-btn
                  >
                  <v-btn
                    class="text-capitalize white--text ml-10"
                    depressed
                    width="120"
                    color="#FF347C"
                    @click="onClick"
                    :loading="loading"
                    >Confirm</v-btn
                  >
                </v-row>
              </v-card-actions>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-spacer></v-spacer>
    <Copyright />
  </v-col>
</template>

<script>
import Copyright from "@/components/Copyright";
import { recoverPassword } from "@/api/api";

export default {
  name: "Login",
  components: {
    Copyright,
  },
  data() {
    return {
      rules: {
        identical: () => {
          if (this.new_password1 !== this.new_password2) {
            return "Passwords must match";
          }
          return true;
        },
        min: (v) => {
          return v.length > 7 || "Password too short";
        },
        num: (v) => {
          var number = /[0-9]/;
          return number.test(v) || "Password must contain numbers";
        },
        letter: (v) => {
          var letter = /[a-zA-Z]/;
          return letter.test(v) || "Password must contain letters";
        },
      },
      new_password1: "",
      new_password2: "",
      loading: false, // property for button loading button state
    };
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    correctPassword() {
      var number = /[0-9]/;
      var letter = /[a-zA-Z]/;
      if (
        this.new_password1 &&
        number.test(this.new_password1) &&
        letter.test(this.new_password1) &&
        this.new_password1.length > 7
      )
        return "Correct Password";
      return "";
    },
    goodPassword2() {
      if (this.new_password2 && this.new_password1 === this.new_password2) {
        return "Passwords match";
      }
      return "";
    },
  },
  created() {
    if (!(this.$route.params.uid || this.$route.params.uid)) {
      this.goLogin();
    }
  },
  methods: {
    goLogin() {
      window.location.assign("/app/auth/login");
    },
    async onClick() {
      this.loading = true;
      const response = await recoverPassword({
        new_password1: this.new_password1,
        new_password2: this.new_password2,
        uid: this.$route.params.uid,
        token: this.$route.params.token,
      });
      if (response) this.goLogin();
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.ubuntu {
  font-family: Ubuntu !important;
}
</style>
